import ExtensionService from 'live/services/extension'
import Form from './integration/form'
import Router from 'live/services/router'
import AdnocAdminPage from './admin/AdminPage'
import ServiceLocator from 'live/services/service-locator'
import { AssetMetadataForm } from './assetMetadataTab/AssetMetadataForm'
import { canManageMetadata, canViewMetadata } from './permission/Permissions'

const extension = {
    name: 'Asset Metadata',
    type: 'asset-metadata',
    origin: 'Live Asset Metadata',
    roles: [],
    icon: '/content/plugin-asset-metadata/icon.png',
    ui: {
        form: Form,
        view: null
    }
}

ExtensionService.register(extension)

const adnocConfig = {
    name: 'Asset Metadata Settings',
    url: '#asset-metadata-config',
    alias: 'asset-metadata-config',
    ico: 'fas fa-cubes',
    position: 'first-block',
    addRoute: false,
    routeUrl: null,
    component: null
}
Router.route('asset-metadata-config', AdnocAdminPage, 'asset-metadata-config')

ExtensionService.addAdminMenu(adnocConfig)

if (canViewMetadata()) {
    try {
        ServiceLocator.getService('asset-tab-service').then(service => {
            // @ts-ignore
            service.register({
                step: `asset-metadata`,
                assetType: `wells`,
                label: 'Asset Metadata',
                shouldHide: false,
                body: AssetMetadataForm
            })
        })
    } catch (e) {
        console.error(e)
    }
}
